/**
 * Баннер разработчика: срез портов устарел или автозагрузка не удалась.
 *
 * Только для роли «Разработчик» — остальным это знать незачем, а сделать
 * что-то с папкой или файлом может только он. Состояние перечитывается
 * раз в десять минут. Закрытый баннер не появится снова, пока положение
 * дел не изменится.
 */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { api } from '../../api/client';
import { selectIsDeveloper } from '../../store/slices/authSlice';
import { portsSliceBanner } from '../../domain/portsSliceStatus';
import Icon from '../common/Icon';
import styles from './PortsSliceBanner.module.css';

const REFRESH_MS = 10 * 60 * 1000;
const DISMISS_KEY = 'sw-ports-banner-closed';

function readDismissed() {
  try { return sessionStorage.getItem(DISMISS_KEY); } catch { return null; }
}

export default function PortsSliceBanner() {
  const isDeveloper = useSelector(selectIsDeveloper);
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(readDismissed);

  useEffect(() => {
    if (!isDeveloper) return undefined;
    let alive = true;
    const load = () => api.get('/api/ports/import-status')
      .then((s) => { if (alive) setStatus(s); })
      .catch(() => { /* баннер — подсказка, без него приложение работает */ });
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => { alive = false; clearInterval(timer); };
  }, [isDeveloper]);

  const banner = isDeveloper ? portsSliceBanner(status) : null;
  if (!banner || banner.key === dismissed) return null;

  function close() {
    setDismissed(banner.key);
    try { sessionStorage.setItem(DISMISS_KEY, banner.key); } catch { /* закроется до перезагрузки */ }
  }

  return (
    <div className={`${styles.banner} ${banner.tone === 'error' ? styles.error : styles.warn}`} role="status">
      <div className={styles.text}>
        <div className={styles.title}>{banner.title}</div>
        {banner.details.map((d) => <div key={d} className={styles.detail}>{d}</div>)}
      </div>
      <div className={styles.actions}>
        <Link className={styles.link} to="/ports">Открыть «Порты»</Link>
        <button type="button" className={styles.close} onClick={close} aria-label="Скрыть до изменений">
          <Icon name="close" size={16} />
        </button>
      </div>
    </div>
  );
}
